import React from 'react';
import PropTypes from 'prop-types';

import pluralize from 'pluralize';
import moment from 'moment/moment';

import { HOUSEHOLD_APPLICATION_ACTION_TO_TEXT_MAPPING } from 'common/householdApplicationActionConstants';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrHouseholdActionItem = ({ userName, createdAt, createdByUserName, actionType }) => {
  const _getDuration = () => {
    const now = moment();
    const then = moment(createdAt);
    const duration = moment.duration(now.diff(then));
    const minutes = duration.asMinutes();
    const hours = duration.asHours();
    const days = duration.asDays();

    if (minutes < 1) {
      return 'Just now';
    }
    if (hours < 1) {
      return `${pluralize('minute', Math.floor(minutes), true)} ago`;
    }
    if (days < 1) {
      return `${pluralize('hour', Math.floor(hours), true)} ago`;
    }
    return `${pluralize('day', Math.floor(days), true)} ago`;
  };

  const duration = _getDuration();
  const actionLabel = HOUSEHOLD_APPLICATION_ACTION_TO_TEXT_MAPPING[actionType] || actionType;
  const apostrophe = userName.slice(-1) === 's' ? "'" : "'s";

  return (
    <SrBox marginBottom="16px">
      <SrBox>
        <SrText font="greycliff" fontSize="12px" color="grey">
          {createdByUserName || 'Sunroom API'} - {duration}
        </SrText>
      </SrBox>
      <SrBox>
        <SrText font="greycliff" fontSize="12px" color="blueGreycliff">
          {actionLabel} in {userName}
          {apostrophe} application
        </SrText>
      </SrBox>
      <SrBox>
        <SrText font="greycliff" fontSize="12px" color="grey">
          {moment(createdAt).format('MMMM Do YYYY, h:mm A')}
        </SrText>
      </SrBox>
    </SrBox>
  );
};

SrHouseholdActionItem.propTypes = {
  userName: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  createdByUserName: PropTypes.string,
  actionType: PropTypes.string.isRequired,
};

SrHouseholdActionItem.displayName = 'SrHouseholdActionItem';

export default SrHouseholdActionItem;
